import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/UserActivityLogs";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const UserSessionLog = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADMINISTRATOR_USER_SESSION_LOGS_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.ADMINISTRATOR_USER_SESSION_LOGS_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.ADMINISTRATOR_USER_SESSION_LOGS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        default:
            return {...state}
    }
}

export default UserSessionLog